import React from "react";
import { useLocation } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  return (
    <footer className={`mpe-footer${isLandingPage ? "" : " mpe-footer--light"}`}>
      <ul className="mpe-footer-links">
        <li><a className="mpe-footer-link" href="/help-resources">Resources</a></li>
        <li><a className="mpe-footer-link" href="/pricing">Pricing</a></li>
        <li><a className="mpe-footer-link" href="/tasks">Try Free</a></li>
        <li><a className="mpe-footer-link" href="/faq">FAQ</a></li>
        <li><a className="mpe-footer-link" href="/privacy-policy">Privacy Policy</a></li>
        <li><a className="mpe-footer-link" href="/terms-of-service">Terms of Service</a></li>
        <li><a className="mpe-footer-link" href="/contact-support">Contact & Support</a></li>
      </ul>
    </footer>
  );
};

export default Footer;